export class Cache {
    value;
    valueTimestamp;
    valueFactory;
    maxAgeInMilliseconds;
    constructor(valueFactory, maxAgeInMilliseconds) {
        this.valueFactory = valueFactory;
        this.maxAgeInMilliseconds = maxAgeInMilliseconds;
    }
    async get() {
        const now = Date.now();
        if ((this.valueTimestamp === undefined) || (now > (this.valueTimestamp + this.maxAgeInMilliseconds))) {
            this.value = await this.valueFactory();
            this.valueTimestamp = now;
        }
        return this.value;
    }
    invalidate() {
        this.value = undefined;
        this.valueTimestamp = undefined;
    }
}
